import { assetsUrlsInterface } from "@/types";
import {
  AssetsApiClientInterface,
  AssetsApi,
} from "@/apiClient/models/api/assets/assetsApiClient.models";

const urls: assetsUrlsInterface = {
  fetch: `${process.env.VUE_APP_API_URL}/{%lang%}/assets`,
  fetchAlbums: `${process.env.VUE_APP_API_URL}/{%lang%}/albums`,
  fetchTags: `${process.env.VUE_APP_API_URL}/{%lang%}/tags`,
  fetchPinnedAssets: `${process.env.VUE_APP_API_URL}/{%lang%}/users/:userId/assets`,
  markAssetAsPinned: `${process.env.VUE_APP_API_URL}/{%lang%}/users/:userId/assets/:assetId`,
  unmarkAssetAsPinned: `${process.env.VUE_APP_API_URL}/{%lang%}/users/:userId/assets/:assetId`,
  sortPinnedAssets: `${process.env.VUE_APP_API_URL}/{%lang%}/users/:userId/assets/sort`,
};

const assetsApiClient: AssetsApiClientInterface = new AssetsApi(urls);

export default assetsApiClient;
